<template>
  <div typeof="schema:Accommodation">

    <div property="schema:name" :content="accommodation.title"></div>
    <div property="schema:description"
         v-if="accommodation.stripDescription && accommodation.stripDescription.length > 0"
         :content="accommodation.stripDescription.substr(0,100)"></div>
    <div rel="schema:image" v-if="accommodation.hasImage()"
         :resource="accommodation.getTopImage().getTyrionSrc('thumb_mw')"></div>
    <div rel="schema:photo" v-if="accommodation.hasImage()"
         :resource="accommodation.getTopImage().getTyrionSrc('thumb_mw')"></div>

    <div property="schema:address"
         :content="`${street ? street : ''} ${streetNumber ? streetNumber : ''}, ${city}, ${country}`"></div>
    <div property="schema:url" :content="WebUrl + '/' + accommodation.link"></div>
  </div>
</template>

<script setup lang="ts">
import {capitalizeFirstLetter} from "~/lib/functions";
import {computed, PropType} from "vue";
import Accommodation from "../../../../lib/models/Accommodation";
import {useRuntimeConfig} from "#app";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>
})

const street = computed(() => {
  return props.accommodation.location.street;
});
const streetNumber = computed(() => {
  return props.accommodation.location.street_number;
});
const city = computed(() => {
  const city = props.accommodation.location.city ? props.accommodation.location.city.title : '';
  return capitalizeFirstLetter(city ? city.replace(/[^a-z\-]/gi, "").replace("-", " ").trim() : "");
});
const country = computed(() => {
  const country = props.accommodation.location ? props.accommodation.location.country_name : false;
  return capitalizeFirstLetter(country ? country : "");
});
const WebUrl = computed(() => {
  return useRuntimeConfig().public.API_URL;
});

</script>
